export enum IconClass {
  CustomFill = 'CustomFill',
  CustomStroke = 'CustomStroke',
}

type ComponentClass = IconClass;

export const classSelector = (classname: ComponentClass) => `.${classname}`;
